module.exports = __webpack_public_path__ + "static/media/RiverPines_farmingtonhills.8c30630e.pdf";